export default class Constants {
	static debug = false
	static lang = "en" // The language in which to display pokemon names, moves, etc.
}
